<template>
    <div
        id="paymentMethod"
        class="form-elements order"
        v-if="paymentMethod || !editable"
    >
        <div class="row">
            <div class="flex xs12">
                <va-card>
                    <form>
                        <div class="row">
                            <div class="flex md6 sm6 xs6">
                                <h1 class="display-1">
                                    {{ paymentMethod.title }}
                                </h1>
                            </div>
                            <div class="flex md6 sm6 xs6 alignRight">
                                <va-button
                                    class="ma-0 mb-2 mt-1 mr-2 btn-to-hide"
                                    icon="va-icon fa fa-save"
                                    @click.prevent="savePaymentMethod"
                                    type="button"
                                    >{{
                                        $t("paymentMethods.savePaymentMethod")
                                    }}</va-button
                                >
                            </div>
                        </div>
                        <div class="row">
                            <div class="flex md2 sm6 xs12">
                                <div
                                    class="va-card__header-title"
                                    :style="{ color: $themes.info }"
                                >
                                    {{ $t("tables.headings.slug") }}
                                </div>
                            </div>
                            <div class="flex md3 sm6 xs12">
                                <va-input
                                    v-model="paymentMethod.slug"
                                    :error="slugError"
                                    :disabled="editable"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="flex md2 sm6 xs12">
                                <div
                                    class="va-card__header-title"
                                    :style="{ color: $themes.info }"
                                >
                                    {{ $t("tables.headings.title") }}
                                </div>
                            </div>
                            <div class="flex md3 sm6 xs12">
                                <va-input
                                    v-model="paymentMethod.title"
                                    :error="titleError"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="flex md2 sm6 xs12">
                                <div
                                    class="va-card__header-title"
                                    :style="{ color: $themes.info }"
                                >
                                    {{ $t("tables.headings.description") }}
                                </div>
                            </div>
                            <div class="flex md5 sm10 xs12">
                                <va-input v-model="paymentMethod.description" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="flex md2 sm6 xs12">
                                <div
                                    class="va-card__header-title"
                                    :style="{ color: $themes.info }"
                                >
                                    {{ $t("tables.headings.fee") }}
                                </div>
                            </div>
                            <div class="flex md3 sm6 xs12">
                                <va-input
                                    type="number"
                                    :error="feeError"
                                    v-model="paymentMethod_fee"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="flex md2 sm6 xs12">
                                <div
                                    class="va-card__header-title"
                                    :style="{ color: $themes.info }"
                                >
                                    {{ $t("paymentMethods.feeFor") }}
                                </div>
                            </div>
                            <div class="flex md3 sm6 xs12">
                                <va-select
                                    textBy="description"
                                    v-model="paymentMethod_feeFor"
                                    :options="customerTypeOptions"
                                />
                            </div>
                        </div>
                    </form>
                    <div
                        class="flex-center loader"
                        id="loader"
                        :class="['flex-center', 'loader', { loading: loading }]"
                    >
                        <spring-spinner
                            :animation-duration="2000"
                            :size="60"
                            :color="$themes.primary"
                        />
                    </div>
                </va-card>
            </div>
        </div>
    </div>
</template>

<script>
import { SpringSpinner } from "epic-spinners";

export default {
    name: "paymentMethod",
    components: {
        SpringSpinner
    },
    data() {
        return {
            paymentMethod: {},
            yetToSend: undefined,
            loading: false,
            titleError: false,
            slugError: false,

            feeError: null,
            paymentMethod_fee: 0,
            paymentMethod_feeFor: {
                id: "no_one",
                description: this.$t("paymentMethods.customerType.no_one")
            },
            customerTypeOptions: [
                {
                    id: "no_one",
                    description: this.$t("paymentMethods.customerType.no_one")
                },
                {
                    id: "private",
                    description: this.$t("paymentMethods.customerType.private")
                },
                {
                    id: "company",
                    description: this.$t("paymentMethods.customerType.company")
                },
                {
                    id: "both",
                    description: this.$t("paymentMethods.customerType.both")
                }
            ]
        };
    },
    created() {
        this.editable = this.$route.params.uuid != 0;
        if (this.editable) {
            this.getPaymentMethod();
            return;
        }
        // per tenere la logica di aggiunta se non è editabile rimando ai metodi di pagamento
        this.$router.push('/admin/payment-methods')
    },
    watch: {
        paymentMethod_fee(t) {
            if (t < 0) {
                this.paymentMethod_fee = 0;
            }
        }
    },
    methods: {
        getPaymentMethod() {
            this.$axios
                .get("api/orders/getPaymentMethod", {
                    params: { uuid: this.$route.params.uuid }
                })
                .then(axRes => {
                    
                    this.paymentMethod = axRes.data;
                    
                    this.paymentMethod_fee = this.paymentMethod.fee / 100;
                    this.paymentMethod_feeFor =
                        this.customerTypeOptions.find(
                            option => option.id == this.paymentMethod.fee_for
                        ) || this.customerTypeOptions[0];
                })
                .catch(axErr => {
                    this.showToast(this.$t("system.genericError"), {
                        icon: "fa-warning",
                        position: "bottom-right",
                        duration: 10000,
                        fullWidth: false,
                        className: "vuestic-toast error"
                    });
                });
        },
        async savePaymentMethod() {
            if (!this.evalFields()) return;

            if (this.editable) {
                this.updatePaymentMethod();
                return;
            }

            this.createPaymentMethod();
        },
        evalFields() {
            this.slugError = false;
            this.titleError = false;
            this.feeError = false;
            let errors = 0;
            if (!this.paymentMethod.title || this.paymentMethod.title == "") {
                this.titleError = true;
                errors +=1;
            }
            if (!this.editable) {
                if (!this.paymentMethod.slug || this.paymentMethod.slug == "") {
                    this.slugError = true;
                    errors +=1;
                }
            }
            if(this.paymentMethod_fee <0 ){
              this.feeError = true ;
              errors +=1;
            }
            return errors == 0;
        },
        async createPaymentMethod() {
            this.loading = true;
            const payload = {
                fee:
                    this.paymentMethod_fee >= 0
                        ? this.paymentMethod_fee * 100
                        : 0,
                feeFor:
                    this.paymentMethod_feeFor.id != "no_one"
                        ? this.paymentMethod_feeFor.id
                        : null,
                title: this.paymentMethod.title,
                description: this.paymentMethod.description,
                slug: this.paymentMethod.slug
            };

  
            try {
                const res = await this.$axios.post(
                    "api/orders/createPaymentMethod",
                    payload
                );
                this.showToast(this.$t("paymentMethods.successCreate"), {
                    icon: "fa-check",
                    position: "bottom-right",
                    duration: 3000,
                    fullWidth: false,
                    className: "vuestic-toast"
                });
                this.yetToSend = false;
                this.loading = false;
                if (!res.data) throw new Error("no data");
                this.$router.push("/admin/payment-method/" + res.data.uuid);
            } catch (e) {
                this.loading = false;
                this.showToast(this.$t("paymentMethods.errorCreate"), {
                    icon: "fa-warning",
                    position: "bottom-right",
                    duration: 10000,
                    fullWidth: false,
                    className: "vuestic-toast error"
                });
            }
        },
        async updatePaymentMethod() {
            this.loading = true;
            const payload = {
                fee: this.paymentMethod_fee * 100,
                feeFor:
                    this.paymentMethod_feeFor.id != "no_one"
                        ? this.paymentMethod_feeFor.id
                        : null,
                title: this.paymentMethod.title,
                description: this.paymentMethod.description,
                uuid: this.paymentMethod.uuid
            };

            try {
                const res = await this.$axios.put(
                    "api/orders/updatePaymentMethod",
                    payload
                );
                this.showToast(this.$t("paymentMethods.successUpdate"), {
                    icon: "fa-check",
                    position: "bottom-right",
                    duration: 3000,
                    fullWidth: false,
                    className: "vuestic-toast"
                });
                this.yetToSend = false;
                this.loading = false;
            } catch (e) {
                this.loading = false;
                this.showToast(this.$t("paymentMethods.errorUpdate"), {
                    icon: "fa-warning",
                    position: "bottom-right",
                    duration: 10000,
                    fullWidth: false,
                    className: "vuestic-toast error"
                });
            }
        }
    }
};
</script>

<style lang="scss">
#paymentMethod{
    .alignRight{
        text-align: right;
    }
}
</style>
